import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let xid = useDataValue({
    context: 'selected',
    path: 'xid',
    viewPath: props.viewPath,
  })

  return useMemo(
    () => ({
      variables: {
        xid,
      },
      context: {
        fetchOptions: {
          headers: {
            'x-hasura-role': 'app-admin-xid',
          },
        },
      },
      pause: !xid,
    }),
    [xid]
  )
}
